module.exports = __webpack_public_path__ + "static/media/23-iveco.d08341ff.jpg";